import { FC, useState } from "react";
import { Box } from "@chakra-ui/react";
import { useDndAsset } from "domains/drag-and-drop";
import { FileQuickActions } from "./fileQuickAction";
import { DisplayFileAsset } from "./displayFileAsset";
import { BaseAssetWrapper } from "../../shared";

export const FileAsset:FC<{ isEditable: boolean }> = ({ isEditable }) => {
  const { asset } = useDndAsset();
  const [ isActive, setIsActive ] = useState(false);

  return (
    <BaseAssetWrapper setIsActive={setIsActive}>
      <DisplayFileAsset asset={asset} />
      { isEditable && (
        <Box position="absolute" top="0px" right="10px" translateY="-50%" zIndex="2">
          <FileQuickActions isActive={isActive} />
        </Box>
      )}
    </BaseAssetWrapper>
  )
}
